import { render, staticRenderFns } from "./alarm-controls.vue?vue&type=template&id=03aff47c&scoped=true&"
import script from "./alarm-controls.vue?vue&type=script&lang=js&"
export * from "./alarm-controls.vue?vue&type=script&lang=js&"
import style0 from "./alarm-controls.vue?vue&type=style&index=0&id=03aff47c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aff47c",
  null
  
)

export default component.exports